export default __webpack_public_path__ + "f50df14aafc79ece1c752b23452781f5.gif";